export const SUCCESSFULLY_SAVE = 'Successfully saved';
export const FAILED_SAVE = 'Failed saved';
export const SUCCESSFULLY_DELETE = 'Successfully deleted';